import { render, staticRenderFns } from "./detail-jadwal-bimbingan.vue?vue&type=template&id=d121f3de"
import script from "./detail-jadwal-bimbingan.vue?vue&type=script&lang=js"
export * from "./detail-jadwal-bimbingan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports